module.exports = __webpack_public_path__ + "static/media/subscribers.54163972.svg";